import * as React from "react";
import { Helmet } from "react-helmet";

interface IPageMetaProps {
  title: string;
  description: string;
}

const PageMeta: React.FunctionComponent<IPageMetaProps> = ({
  title,
  description,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default PageMeta;
